import Loading from './load.vue'

const load = {
  install(Vue) {
    if (typeof window !== 'undefined' && window.Vue) {
      Vue = window.Vue
    }
    let newLoad=null;

   // Vue.component('Loading', Loading)
    function msg(spinning, callBack) {
      let Vueload = Vue.extend({
          render(h) {
            let props = {
              spinning: this.spinning
            }
            return h(Loading,{props})
          },
      
        data() {
          return {
            spinning: false
          }
        },
      })
       return new Vueload()
    }
    Vue.prototype.$load ={
     // document.body.removeChild(script);
      show(){
        newLoad=!newLoad?msg():newLoad
        newLoad.$mount()
        document.body.appendChild(newLoad.$el)
        newLoad.spinning = true
      },
      
      close(){
       // msg(false)
       if(!newLoad) return
        newLoad.spinning = false
        document.body.removeChild(newLoad.$el);
        newLoad=null


      }

    } 
  }
}
export default load